import '#components/Tag/styles.css'
export const Tag = ({ children, variant, ...props }) => {
  return (
    <span className={`tag is-${variant}`} {...props}>
      {children}
    </span>
  )
}
